import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // ✅ import this

// Import your JSON files
import translationFR from './locales/fr/translation.json';
import translationAR from './locales/ar/translation.json';

// the translations
const resources = {
  fr: { translation: translationFR },
  ar: { translation: translationAR },
};

i18n
  .use(LanguageDetector) // ✅ use the language detector
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr', // default if nothing found
    detection: {
      // ✅ detect and cache language
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
